<template>
  <div class="text-center" fill-height fluid>
    <v-dialog scrollable v-model="dialog" width="900">
      <template v-slot:activator="{ on, attrs }"></template>

      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div class="text-justify body-1 black--text">
                <p class="headline primary--text font-weight-bold py-2">
                  Token
                </p>
                <p>
                  Berikut ini Merupakan list token yang Anda miliki. Token dapat Anda bagikan Kepada sahabat PAUD lainnya yang ingin mengikuti diklat.
                </p>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="black--text">No</th>
                      <th class="black--text">Token</th>
                      <th class="black--text">Status</th>
                      <th class="black--text">Nama Lengkap</th>
                      <th class="black--text">Akun/Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(token, index) in current_user.tokens" :key="token.index">
                      <td>{{ index + 1 }}</td>
                      <td class="body-1 purple--text text--darken-3 font-weight-bold">{{ token.token }}</td>
                      <td class="body-1">
                        <template v-if="token.used_by">
                          <v-icon color="green">mdi-circle</v-icon> Sudah digunakan
                        </template>
                        <template v-else>
                          <v-icon color="grey">mdi-circle</v-icon> Belum digunakan
                        </template>
                      </td>
                      <td>{{ token.usedby ? token.usedby.name : "-" }}</td>
                      <td>{{ token.usedby ? token.usedby.email : "-" }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="body-1" class="ma-2" text @click="closeGuide">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const lc = window.localStorage;
const VIDEO = "VIDEO";
export default {
  data() {
    return {
      dialog: false
    };
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },

    closeGuide() {
      lc.setItem(VIDEO, false);
      this.dialog = false;
      this.resolve();
    },
    toVideo() {
      window.open("https://www.youtube.com/watch?v=x-wVxbHtvOU", "_blank");
    }
  }
};
</script>
